import PagesView from "../PagesView.vue";
import HomeEditor from "../Pages/HomeEditor.vue";
// Las páginas estáticas siguen en el módulo Config; aquí solo cambian de menú y de ruta
import PagesList from "@/modules/Config/Pages/PagesList.vue";
import PagesEditor from "@/modules/Config/Pages/PagesEditor.vue";

const routes = [
  {
    path: '/contenido',
    component: PagesView,
    plan: ['ALL'],
    name: 'pages',
    children: [
      {
        path: 'portada',
        name: 'pages-home-editor',
        plan: ['ALL'],
        component: HomeEditor
      },
      {
        path: 'paginas',
        name: 'pages-list',
        plan: ['ALL'],
        component: PagesList
      },
      {
        path: 'paginas/crear',
        name: 'pages-create',
        plan: ['ALL'],
        component: PagesEditor
      },
      {
        path: 'paginas/:id/editar',
        name: 'pages-edit',
        plan: ['ALL'],
        component: PagesEditor
      }
    ]
  },
]

export default routes
